import React, { forwardRef } from 'react';
import isFunction from 'lodash/isFunction';
import { NumericFormat, PatternFormat } from 'react-number-format';

const NumberFormat = forwardRef(({ value, format = {}, ...props }, ref) => {
  if (isFunction(format?.format)) {
    return <span>{format.format(value)}</span>;
  } else if (format?.format) {
    return <PatternFormat {...props} {...format} value={value} ref={ref} />;
  } else {
    return <NumericFormat {...props} {...format} value={value} ref={ref} />;
  }
});

export default NumberFormat;
